let Footnotes = Vue.component('footnotes', {
	props: ['items'],
	template: `
		<ul class="footnotes">
			<li v-for="(footnote, index) in items" :data-footnote-number="index + 1" v-html="footnote.footnote"></li>
		</ul>`
})

export default Footnotes
